import React from 'react'

const BookmarkIcon = () => {
    return (
        <svg
            // width="24" height="24"
            style={{ width: '100%' }}
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.52148 5.83285C3.52148 3.15727 5.69047 0.988281 8.36606 0.988281H15.6329C18.3085 0.988281 20.4775 3.15727 20.4775 5.83285V21.7816C20.4775 22.7398 19.4174 23.3185 18.6114 22.8004L13.3094 19.3919C12.5114 18.879 11.4875 18.879 10.6896 19.3919L5.38757 22.8004C4.58154 23.3185 3.52148 22.7398 3.52148 21.7816V5.83285Z" stroke="#2B3F6C" stroke-width="1.81671" />
            <path opacity="0.3" d="M8.36719 7.64952H15.634" stroke="#2B3F6C" stroke-width="1.81671" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}

export default BookmarkIcon